import z from 'zod';

export const approvalNotesSchema = z.object({
  transactionSummary: z.string().optional().default(''),
  lenderNotes: z.string().optional().default(''),
  internalNotes: z.string().optional().default(''),
  stage: z.number().nullable().optional(),
});
